import api from '@/services/api-service';
import RestResource from '@/services/resources/restResource';

export class ItemsResource extends RestResource {
    /**
     *
     * @param {ApiClient} apiClient
     * @param {string} endpoint
     */
    constructor(apiClient, endpoint = 'items') {
        super(apiClient, endpoint);
    }

    suggest(query, config) {
        return this.api.post(`${this.endpoint}/suggestions`, query, config);
    }

    get(query, config = {}) {
        return this.api.get(`${this.endpoint}`, query, config);
    }

    getSku(sku) {
        return this.api.get(`${this.endpoint}/getItem?sku=${sku}`);
    }

    updateItem(payload, config = {}) {
        return this.api.put(`${this.endpoint}`, payload, config);
    }

    deleteItem(payload, config = {}) {
        return this.api.delete(`${this.endpoint}`, payload, config);
    }

    bulkUpload(payload, config = {}) {
        return this.api.post(`${this.endpoint}/bulkUpload`, payload, config);
    }

    getItemsExportPath() {
        return `${this.api.baseURL}/items/csv`;
    }

    search(pageNumber = 1, query = '') {
        return this.api.get(`${this.endpoint}?page=${pageNumber}&pageSize=100&searchQuery=${query}`);
    }

    updateHSCodes(payload, config = {}) {
        return this.api.post(`${this.endpoint}/updateHSCodes`, payload, config);
    }
}

export default new ItemsResource(api);
